<template>
  <el-card class="box-card full-screen">
    <div ref="pageHead" class="table-page-head">
      <el-form :inline="true" :model="queryForm">      
          <el-form-item :label="$t('date')">
            <el-date-picker v-model="queryForm.date" type="daterange" range-separator="~" :start-placeholder="$t('startDate')" :end-placeholder="$t('endDate')" 
            value-format="yyyy-MM-dd" size="small" unlink-panels :clearable="true" :picker-options="pickerOptions0" @change='changeDate'>
            </el-date-picker>
          </el-form-item>
        <el-form-item>
          <el-button type="primary" size="small" @click="getList" :loading="isloading"><i class="el-icon-search"></i> {{$t('query')}}</el-button>
        </el-form-item>
      </el-form>
      
    </div>
    <div> 
    <el-row class="table-btns">
      <a @click="downloadPDF()" type="text" size="mini"><i class="el-icon-download"></i> {{$t('downloadPDF')}}</a>
    </el-row>
  </div>
    <div class="data-table" :style="{top:queryTableHeight,height:`calc(100% - ${queryTableHeight} - 70px)`}">
      <el-table :data="tableData.records" v-loading="isloading" element-loading-background="rgba(255,255,255,0.4)" size="mini" height="100%">
        <el-table-column align="center" :label="$t('remittanceInfo')" min-width="160" class-name="multiple-header-intervals">
          <el-table-column prop="" :label="$t('compellation')" min-width="160">
            <template slot-scope="scope">{{scope.row.remitterName}} {{scope.row.remitterSurname}}</template>
          </el-table-column>
          <el-table-column prop="remitterPhone" :label="$t('linkPhone')" min-width="160"></el-table-column>
          <el-table-column prop="remitterIdCard" :label="$t('idNumber')" min-width="160"></el-table-column>
          <el-table-column prop="remitterAmount" :label="$t('remittanceAmount')" min-width="160">
            <template slot-scope="scope"><span class="franc">₣</span>{{scope.row.remitterAmount.replace("-","").split(".")[0].formatMoney(0)}}</template>
          </el-table-column>
          <el-table-column prop="remitterCreateTime" :label="$t('remittance time')" min-width="160">
            <template slot-scope="scope">{{scope.row.remitterCreateTime?$manba(scope.row.remitterCreateTime).format('ymdhms'):""}}</template>
          </el-table-column>
          <el-table-column prop="remitterOrgInfoId" :label="$t('orgInfoId')" min-width="160" class-name="multiple-header-intervals"></el-table-column>
          
          <el-table-column prop="remitterOrgName" :label="$t('operateOrg')" min-width="160" class-name="multiple-header-intervals"></el-table-column>
          <el-table-column prop="businessTypeName" :label="$t('businessName')" min-width="160" class-name="multiple-header-intervals">
              <template slot-scope="scope">
                  {{ $t(scope.row.businessTypeName) }}
              </template>
          </el-table-column>
          <el-table-column prop="lotExcelName" :label="$t('FileName')" min-width="160" class-name="multiple-header-intervals">
              <template slot-scope="scope">
                  {{ $t(scope.row.lotExcelName) }}
              </template>
          </el-table-column>
        </el-table-column>
        <el-table-column align="center" :label="$t('withdrawalInfo')" min-width="160">
          <el-table-column prop="" :label="$t('compellation')" min-width="160">
            <template slot-scope="scope">{{scope.row.payeeName}} {{scope.row.payeeSurname}}</template>
          </el-table-column>
          <el-table-column prop="payeePhone" :label="$t('linkPhone')" min-width="160"></el-table-column>
          <el-table-column prop="payeeIdCard" :label="$t('idNumber')" min-width="160"></el-table-column>
          <el-table-column prop="address" :label="$t('address')" min-width="200">
            <template slot-scope="scope">{{getRegionName([scope.row.country,scope.row.region,scope.row.city])}}</template>
          </el-table-column>
          <el-table-column prop="status" :label="$t('status')" min-width="160">
            <template slot-scope="scope">
              <span v-if="scope.row.status==2" type="text-success">{{$t('already withdrawal')}}</span>
              <span v-if="scope.row.status==1" type="text-warning">{{$t('without withdrawal')}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="payeeAmount" :label="$t('withdrawalAmount')" min-width="160">
            <template slot-scope="scope"><span class="franc">₣</span>{{scope.row.payeeAmount.split(".")[0].formatMoney(0)}}</template>
          </el-table-column>
          <el-table-column prop="payeeDoneTime" :label="$t('withdrawal time')" min-width="160">
            <template slot-scope="scope">{{scope.row.payeeDoneTime?$manba(scope.row.payeeDoneTime).format('ymdhms'):""}}</template>
          </el-table-column>
          <el-table-column prop="payeeOrgName" :label="$t('operateOrg')" min-width="160"></el-table-column>
        </el-table-column>
        
      </el-table>
    </div>
    <el-pagination background layout="total,sizes,prev,pager,next,jumper" :total="tableData.total" :page-sizes="[20, 30, 50, 100, 200]" :page-size="pageSize" :current-page="currentPage" @size-change="setPageSzie" @current-change="setCurrentChange" @prev-click="setCurrentChange" @next-click="setCurrentChange" />

        <!-- PDF -->
        <el-dialog :title="$t('printTable')" :visible.sync="printVisible" width="500px" :modal-append-to-body="false" :destroy-on-close="true" :close-on-press-escape="false" :close-on-click-modal="false">
  <print-credentials :param="printParam" :isClosePrint.sync="printVisible" />
</el-dialog>
    
  </el-card>
</template>

<script>
import org from '@/api/org'
import transactionInfo from '@/api/transactionInfo'
import PrintCredentials from '@/components/printBatchRecord.vue';
//import printBatchRecord from '@/components/printBatchRecord';
//import PrintBatchRecord from '@/components/printBatchRecord.vue';


export default {
  components: {
    PrintCredentials,
  //PrintBatchRecord,
},

  name: "batchTransferList",
  data () {
    return {
      queryForm: {},
      // queryForm: { queryObject: 1 },
      queryTableHeight: String,
      orgList: [],
      tableData: {},
      pageSize: 20,
      currentPage: 1,
      isloading: false,

      editVisible: false,
      editForm: {},
      surplusTime: 0,

      printVisible: false,
      printParam: null,
      
      pickerOptions0: {
      onPick: ({ maxDate, minDate }) => {
        this.minDate = minDate;
        this.maxDate = maxDate;
      },
      disabledDate: (time) => {
        let today = 3 * 30 * 24 * 3600 * 1000;
        if (this.minDate) {
          return time.getTime() > Date.now() || time > new Date(this.minDate.getTime() + today) || time < new Date(this.minDate.getTime() - today)
        }
        return time.getTime() > Date.now();
      },
    },
    }
  },
  computed: {
    loginInfo () { return this.$store.state.globalParameter.loginInfo; },
    cascader () { return this.$store.state.format.cascader },
    countryTree () { return this.$store.state.globalParameter.countryTree; },
    countryList () { return this.$store.state.globalParameter.countryList; },
    rules () {
      return {
          date: [{ required: true, message: this.$t('requiredFields'), trigger: 'blur' }],
      }
    }
  },
  watch: {
  "queryForm.date" (newVal) {
    if (newVal && newVal.length > 0) {
      this.queryForm.startTime = this.queryForm.date[0];
      this.queryForm.endTime = this.queryForm.date[1];
    } else {
      this.queryForm.startTime = undefined;
      this.queryForm.endTime = undefined;
    }
  },
},
  methods: {
    getList () {
      let _this = this;
      _this.isLoading = true;
      let params = JSON.parse(JSON.stringify(_this.queryForm))
      if (params.date && params.date.length > 0) {
              params.startTime = _this.$manba(params.date[0]).format('ymd');
              params.endTime = _this.$manba(params.date[1]).format('ymd');
      }
      else {
              params.startTime = undefined;
              params.endTime = undefined;
      }
          delete params.date;

      transactionInfo.pageBatchTransferList({
        param: { current: _this.currentPage, size: _this.pageSize, ...params },
        success: res => {
          _this.isLoading = false;
          _this.tableData = res.data || {};

           // Pass the records array to the print component
           _this.$set(_this, "printParam", res.data.records); // Ensure this is an array

        }
      })
    },

    downloadPDF() {
        let _this = this;
      _this.isLoading = true;
      let params = JSON.parse(JSON.stringify(_this.queryForm))
      if (params.date && params.date.length > 0) {
          _this.$set(_this, "printVisible", true);

      }else {
              params.startTime = undefined;
              params.endTime = undefined;
              _this.$message.warning(_this.$t('no data'))
               _this.isLoading = false;
      }
  },
    
    changeDate (e) {
    if (e === null) {
      this.minDate = "";
      this.maxDate = "";
      this.pickerBeginDateBefore = {
        disabledDate: (time) => {
          let three = 3 * 30 * 24 * 3600 * 1000;
          if (this.minDate) {
            return time.getTime() > Date.now() || time > new Date(this.minDate.getTime() + three) || time < new Date(this.minDate.getTime() - three)
          }
          return time.getTime() > Date.now();
        },
      };
    }
  },
    getRegionName (arr) {
      let name = "";
      for (let i in arr) {
        let tt = this.countryList.find(function (t) { return t.id == arr[i] });
        name += tt ? (tt.name + ' ') : "";
      }
      return name.substring(0, name.length - 1)
    },
    getOrgList () {
      let _this = this;
      org.getOrgInfoPage({
        param: { current: 1, size: 10000, },
        success: res => {
          if (res.data)
            _this.orgList = res.data.records;
        }
      })
    },
    setPageSzie (val) {
      this.pageSize = val;
      this.getList();
    },
    setCurrentChange (val) {
      this.currentPage = val;
      this.getList();
    },

  },
  mounted () {
    let queryTableHeight = this.$refs.pageHead.offsetHeight + 15;
    this.queryTableHeight = queryTableHeight + 'px';

    this.getList()

    this.getOrgList();
  }
}
</script>
<style lang="less" >
</style>